export const skinCustom = {
  lightComponents: {
    body: '#ECEFF1',
    gradient: {
      gradientDefault1: '#f9f220',
      gradientDefault2: '#078e1c',
    },
  },
  darkComponents: {
    body: '#263238',
    gradient: {
      gradientDefault1: '#172260',
      gradientDefault2: '#000000',
    },
  },
}

export const image = {
  principal: 'https://certificadoacemc.com.br//image-bank/acemecremovebg.png',
  favicon: '/cadeadosd.png',
}

export const seo = {
  titulo: 'ACEMC - Associação Comercial e Empresarial Santa Cruz de Monte Castelo',
  email: 'suporte@senhadigital.com.br',
  palavrasChave:
    'Certificado Digital, Cnpj a1, Cpf a1, emitir certificado, certificado curitiba',
  descricao:
    'Empresa líder em Certificação Digital, oferecendo soluções seguras e confiáveis para empresas e indivíduos, com ampla experiência no mercado.',
  descricaoPWA:
    'Certificados digitais são identidades eletrônicas seguras usadas para autenticar usuários, proteger informações e realizar transações online com segurança.',
}

export const header = {
  empresa: false,
  solucoes: false,
  contato: true,
  trabalheConosco: false,
  duvidasSuporte: true,
  parcerias: false,
  darkMode: false,
  contaLogin: true,
}

export const contentHome = {
  sispass: true,
  produtorRural: true,
  modalidadesCertificado: true,
}

export const footer = {
  is0800: false,
  telefone: '44 34521-385',
  whatsapp: '44 99115-6933',
  botaoRenocao: '44991156933',
  comercial: '44991156933',
  botaoWhatsapp: '44991156933',
  number0800: '0800 600 2710',
  cidadeuf: 'Santa Cruz de Monte Castelo/PR',
  cidade: 'Santa Cruz de Monte Castelo',
  bairro: 'Centro',
  titulo: 'Certificado Digital em Santa Cruz de Monte Castelo',
  rua: 'Rua Pará',
  numero: '480',
  complemento: '',
  cep: '87920-000',
  cnpj: '00.806.716/0000-18',
  messageContador: 'Olá, tenho interesse em ser Parceiro Indicador.',
  messageRevenda: 'Olá, tenho interesse em revender Certificados Digitais',
  messageAgendamento: 'Olá, gostaria de agendar a emissão do meu Certificado',
  messageRenovacao: 'Olá, gostaria de renovar meu Certificado Digital',
  messageRenovacaoSispass:
    'Olá, gostaria de renovar meu Certificado Digital Sispass',
  messageConhecaNossasSolucoes:
    'Olá, gostaria de conhecer as soluções',
}

export const redes = {
  facebook: 'https://www.facebook.com/p/ACEMC-Associa%C3%A7%C3%A3o-Comercial-e-Empresarial-de-Santa-Cruz-de-Monte-Castelo-100064656733021/',
  instagram: 'https://www.instagram.com/acemcpr/',
  linkedin: '',
}

export const digisac = {
  id: 'df7a6a14-269a-46ba-a874-33c45e74badf',
  status: false,
}

export const ratings = [
  {
    id: 1,
    descricao: 'Suporte e Atendimento excelentes!',
    author: 'Leonardo Lopes',
    ratingvalue: 5,
  },
  {
    id: 2,
    descricao:
      'Atendimento excelente. Super ágil, prático e simplificado! Ótima organização da equipe.',
    author: 'Tháliton Morais',
    ratingvalue: 5,
  },
  {
    id: 3,
    descricao: 'Atendimento do Suporte Técnico nota 10!.',
    author: 'Felipe Mourão',
    ratingvalue: 5,
  },
]
